(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // RESADE (K17, Rückmeldung 02.10.2026, Ladezeit am Handy): Shrine las beim Einrichten offsetHeight (erzwungenes
  // Layout) und schrieb --header-height bei jedem Aufruf an html, was jedes Mal alle Stile der Seite durchrechnen ließ. Die Höhe
  // kommt aus einem ResizeObserver nach dem Layout und wird nur geschrieben, wenn sie vom geltenden Wert abweicht.
  // Den Startwert (64 px, ab 991 px 84 px, gemessen) setzt rs-base.css, damit im Normalfall nichts geschrieben wird.
  function rsKopfhoeheBeobachten(kopf) {
    if (!kopf || kopf.rsKopfBeobachter) return;
    const wurzel = document.documentElement;
    const schreiben = (hoehe) => {
      const wert = `${Math.round(hoehe)}px`;
      if (getComputedStyle(wurzel).getPropertyValue('--header-height').trim() === wert) return;
      wurzel.style.setProperty('--header-height', wert);
    };
    if (!('ResizeObserver' in window)) {
      schreiben(kopf.offsetHeight);
      return;
    }
    kopf.rsKopfBeobachter = new ResizeObserver((eintraege) => {
      const box = eintraege[eintraege.length - 1].borderBoxSize;
      schreiben(box && box[0] ? box[0].blockSize : kopf.offsetHeight);
    });
    kopf.rsKopfBeobachter.observe(kopf, { box: 'border-box' });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // RESADE (K17): der ResizeObserver deckt auch den Wechsel bei 990 px ab
      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      rsKopfhoeheBeobachten(this.header);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // RESADE (K17): der ResizeObserver deckt auch den Wechsel bei 990 px ab
      this.setHeaderHeight();
    }

    setHeaderHeight() {
      rsKopfhoeheBeobachten(this.header);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Sprungziel #gewaehrleistung sichern: trägt es weder die Buybox noch diese Section, bekommt es die
    // kompakte EU-Mitteilung hier (eine id je Seite).
    function rsEuAnker() {
      if (document.getElementById('gewaehrleistung')) return;
      var el = document.querySelector('[data-rs-eu-rueckfall]');
      if (!el) return;
      el.id = 'gewaehrleistung';
      el.setAttribute('tabindex', '-1');
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rsEuAnker);
    } else {
      rsEuAnker();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-groessen"] && !Shopify.designMode) return;
  try {
    
  function rsGrFarbeAusUrl(sektion) {
    var f = null;
    try {
      f = new URLSearchParams(window.location.search).get('farbe');
    } catch (e) {
      return null;
    }
    if (!f) return null;
    f = f.toLowerCase();
    if (f === '1' || f === sektion.getAttribute('data-rs-farbname-1')) return '1';
    if (f === '2' || f === sektion.getAttribute('data-rs-farbname-2')) return '2';
    return null;
  }

  var rsGrFarbe = null;

  function rsGrStill(region, fn) {
    region.setAttribute('aria-live', 'off');
    fn();
    window.setTimeout(function () { region.setAttribute('aria-live', 'polite'); }, 60);
  }

  function rsGrZeigen(sektion, stumm) {
    var karte = sektion.querySelector('[data-rs-tipp]');
    if (!karte) return;
    var text = karte.querySelector('[data-rs-tipp-text]');
    var link = karte.querySelector('[data-rs-tipp-link]');
    var buehne = karte.querySelector('[data-rs-buehne]');
    var bilder = karte.querySelector('[data-rs-tipp-bilder]');
    var f = rsGrFarbe || rsGrFarbeAusUrl(sektion) || sektion.getAttribute('data-rs-farbe') || '1';
    var gewaehlt = sektion.querySelector('input[data-rs-antwort]:checked');
    var labels = sektion.querySelectorAll('.rs-groessen__antwort');
    for (var i = 0; i < labels.length; i++) {
      var inp = labels[i].querySelector('input');
      labels[i].classList.toggle('ist-gewaehlt', !!(inp && inp.checked));
    }
    if (!gewaehlt) {
      karte.classList.add('ist-leer');
      karte.classList.remove('hat-bild');
      if (link) link.hidden = true;
      if (buehne) buehne.hidden = true;
      if (bilder) bilder.hidden = true;
      return;
    }
    // E-166: Bild zur Antwort in der gewählten Farbe; fehlt es, bleibt die Bühne der Rückfall
    var hatBild = false;
    if (bilder) {
      var figuren = bilder.querySelectorAll('[data-rs-tipp-bild]');
      for (var k = 0; k < figuren.length; k++) {
        var zeigen = figuren[k].getAttribute('data-antwort') === gewaehlt.value && figuren[k].getAttribute('data-farbe') === f;
        figuren[k].hidden = !zeigen;
        if (zeigen) hatBild = true;
      }
      bilder.hidden = !hatBild;
    }
    karte.classList.toggle('hat-bild', hatBild);
    var neu = gewaehlt.getAttribute('data-text-' + f) || gewaehlt.getAttribute('data-text-1') || '';
    var kern = gewaehlt.getAttribute('data-kern-' + f) || gewaehlt.getAttribute('data-kern-1') || '';
    // E-171: der Tipp selbst als eigener Teil (span.rs-groessen__tipp-kern), der Rest als Textknoten dahinter
    function setzeText() {
      text.textContent = '';
      if (kern && neu.indexOf(kern) === 0) {
        var k = document.createElement('span');
        k.className = 'rs-groessen__tipp-kern';
        k.textContent = kern;
        text.appendChild(k);
        if (neu.length > kern.length) text.appendChild(document.createTextNode(neu.slice(kern.length)));
      } else {
        text.textContent = neu;
      }
    }
    if (text && (text.textContent !== neu || !text.querySelector('.rs-groessen__tipp-kern') !== !kern)) {
      if (stumm) rsGrStill(text, setzeText);
      else setzeText();
    }
    if (link) {
      // Duo 20 % (01.10.2026): ohne Ziel (Pfannen-Duo in beiden Farben gesperrt) kein Link in die Auswahl
      var ziel = gewaehlt.getAttribute('data-href') || '';
      if (ziel) {
        link.setAttribute('href', ziel);
        link.setAttribute('data-rs-setzen', gewaehlt.getAttribute('data-setzen'));
        link.hidden = false;
      } else {
        link.hidden = true;
      }
    }
    karte.classList.remove('ist-leer');
    if (buehne && hatBild) {
      buehne.hidden = true;
    } else if (buehne) {
      var groessen = (gewaehlt.getAttribute('data-groessen') || '').split(' ');
      var pfannen = buehne.querySelectorAll('[data-groesse]');
      var anzahl = 0;
      for (var j = 0; j < pfannen.length; j++) {
        var an = pfannen[j].getAttribute('data-farbe') === f && groessen.indexOf(pfannen[j].getAttribute('data-groesse')) !== -1;
        pfannen[j].hidden = !an;
        if (an) anzahl++;
      }
      buehne.setAttribute('data-anzahl', String(anzahl));
      buehne.hidden = anzahl === 0;
    }
  }

  function rsGrRuhig(sektion) {
    if (sektion && sektion.getAttribute('data-rs-bewegung') === 'false') return true;
    if (document.documentElement.classList.contains('ohne-bewegung')) return true;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function rsGrZurAuswahl(ev, link) {
    var ziel = document.getElementById('auswahl');
    if (!ziel) return;
    var detail = {};
    try {
      detail = JSON.parse(link.getAttribute('data-rs-setzen') || '{}');
    } catch (e) {
      return;
    }
    ev.preventDefault();
    document.dispatchEvent(new CustomEvent('rs:buybox:setzen', { bubbles: true, detail: detail }));
    var sektion = link.closest('[data-rs-groessen]');
    window.requestAnimationFrame(function () {
      var titel = /^H[1-6]$/.test(ziel.tagName) ? ziel : (ziel.querySelector('[data-rs-auswahl-titel]') || ziel.querySelector('h2') || ziel);
      var sprung = ziel.closest('[data-rs-buybox]') || ziel.closest('form') || ziel.querySelector('[data-rs-buybox]') || ziel;
      if (!titel.hasAttribute('tabindex')) titel.setAttribute('tabindex', '-1');
      try {
        titel.focus({ preventScroll: true });
      } catch (e) {
        titel.focus();
      }
      sprung.scrollIntoView({ behavior: rsGrRuhig(sektion) ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function rsGrAlle(wurzel) {
    var liste = (wurzel || document).querySelectorAll('[data-rs-groessen]');
    for (var i = 0; i < liste.length; i++) rsGrZeigen(liste[i], true);
  }

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('[data-rs-groessen] input[data-rs-antwort]')) return;
    rsGrZeigen(t.closest('[data-rs-groessen]'), false);
  });

  document.addEventListener('focusin', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('[data-rs-groessen] input[data-rs-antwort]')) return;
    var label = t.closest('.rs-groessen__antwort');
    if (label && t.matches(':focus-visible')) label.classList.add('ist-fokus');
  });

  document.addEventListener('focusout', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('[data-rs-groessen] input[data-rs-antwort]')) return;
    var label = t.closest('.rs-groessen__antwort');
    if (label) label.classList.remove('ist-fokus');
  });

  document.addEventListener('click', function (ev) {
    var link = ev.target && ev.target.closest ? ev.target.closest('[data-rs-groessen] [data-rs-tipp-link]') : null;
    if (link) rsGrZurAuswahl(ev, link);
  });

  document.addEventListener('rs:buybox:geaendert', function (ev) {
    var d = ev.detail || {};
    var z = d.zustand || d;
    var f = z && z.farbe != null ? String(z.farbe) : null;
    if (f !== '1' && f !== '2') return;
    if (f === rsGrFarbe) return;
    rsGrFarbe = f;
    rsGrAlle(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { rsGrAlle(document); });
  } else {
    rsGrAlle(document);
  }
  document.addEventListener('shopify:section:load', function (e) { rsGrAlle(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-preistreppe"] && !Shopify.designMode) return;
  try {
    
  var rsPtFarbe = null;

  function rsPtFarbeSetzen(wurzel, f) {
    var liste = (wurzel || document).querySelectorAll('[data-rs-preistreppe] [data-rs-b1]');
    for (var i = 0; i < liste.length; i++) {
      var t = liste[i].getAttribute('data-rs-b' + f);
      if (t && liste[i].textContent !== t) liste[i].textContent = t;
    }
    // Duo 20 % (01.10.2026): Teile mit gesperrtem Pfannen-Duo der Farbe ausblenden (data-rs-ok1, data-rs-ok2)
    var teile = (wurzel || document).querySelectorAll('[data-rs-preistreppe] [data-rs-ok1]');
    for (var k = 0; k < teile.length; k++) teile[k].hidden = teile[k].getAttribute('data-rs-ok' + f) !== 'true';
  }

  function rsPtRuhig(sektion) {
    if (sektion && sektion.getAttribute('data-rs-bewegung') === 'false') return true;
    if (document.documentElement.classList.contains('ohne-bewegung')) return true;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function rsPtZurAuswahl(ev, link) {
    var ziel = document.getElementById('auswahl');
    if (!ziel) return;
    var detail = {};
    try {
      detail = JSON.parse(link.getAttribute('data-rs-setzen') || '{}');
    } catch (e) {
      return;
    }
    ev.preventDefault();
    document.dispatchEvent(new CustomEvent('rs:buybox:setzen', { bubbles: true, detail: detail }));
    var sektion = link.closest('[data-rs-preistreppe]');
    window.requestAnimationFrame(function () {
      var titel = /^H[1-6]$/.test(ziel.tagName) ? ziel : (ziel.querySelector('[data-rs-auswahl-titel]') || ziel.querySelector('h2') || ziel);
      var sprung = ziel.closest('[data-rs-buybox]') || ziel.closest('form') || ziel.querySelector('[data-rs-buybox]') || ziel;
      if (!titel.hasAttribute('tabindex')) titel.setAttribute('tabindex', '-1');
      try {
        titel.focus({ preventScroll: true });
      } catch (e) {
        titel.focus();
      }
      sprung.scrollIntoView({ behavior: rsPtRuhig(sektion) ? 'auto' : 'smooth', block: 'start' });
    });
  }

  document.addEventListener('click', function (ev) {
    var link = ev.target && ev.target.closest ? ev.target.closest('[data-rs-preistreppe] [data-rs-setzen]') : null;
    if (link) rsPtZurAuswahl(ev, link);
  });

  document.addEventListener('rs:buybox:geaendert', function (ev) {
    var d = ev.detail || {};
    var z = d.zustand || d;
    var f = z && z.farbe != null ? String(z.farbe) : null;
    if (f !== '1' && f !== '2') return;
    rsPtFarbe = f;
    rsPtFarbeSetzen(document, f);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (rsPtFarbe) rsPtFarbeSetzen(e.target, rsPtFarbe);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-probekochen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function rsBedingungenOeffnen() {
      var h = window.location.hash;
      if (h !== '#bedingungen') return;
      var d = document.querySelector('details[data-rs-bedingungen]');
      if (d && !d.open) d.open = true;
      // Runde 5 (E-156): ohne Aufklapper öffnet der Anker den kleinen Dialog, sobald rs-fotodialog.js bereit ist
      var dlg = document.querySelector('dialog[data-rs-bedingungen-dialog]');
      var knopf = dlg ? document.querySelector('[aria-controls="' + dlg.id + '"]') : null;
      if (dlg && knopf && !dlg.open) {
        var versuch = 0;
        (function klick() {
          if (knopf.rsFotodialogAn) { knopf.click(); return; }
          if (++versuch < 40) setTimeout(klick, 50);
        })();
      }
    }
    window.addEventListener('hashchange', rsBedingungenOeffnen);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', rsBedingungenOeffnen);
    } else {
      rsBedingungenOeffnen();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
